<template>
  <div class="finish">
    <h3 v-if="$route.query.flat == 'login'">{{ $t('lang.密码设置成功') }}</h3>
    <h3 v-else>{{ $t('lang.密码重置成功') }}</h3>
    <p>{{$t('lang.请使用您的账号（邮箱地址）与密码登录Cofar品牌商管理平台')}}</p>
    <el-button size="medium" type="primary" style="width: 120px;margin-top: 34px" @click="$router.push('/login')  ">
      {{ $t('lang.去登录') }}
    </el-button>
  </div>

</template>

<script>
export default {
  name: "SetPasswordFinish"
}
</script>

<style scoped>

.finish {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center
}

</style>
